import React from 'react';
import { timelineData } from '../data/mock';
import * as LucideIcons from 'lucide-react';

const TimelineItem = ({ item, index, isLast }) => {
  const IconComponent = LucideIcons[item.icon] || LucideIcons.Circle;
  
  return (
    <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
      <div className="timeline-connector">
        <div className="timeline-dot">
          <IconComponent size={20} />
        </div>
        {!isLast && <div className="timeline-line"></div>}
      </div>
      
      <div className="timeline-content">
        <span className="timeline-year">{item.year}</span>
        <h4 className="heading-5">{item.title}</h4>
        <p className="body-small">{item.description}</p>
      </div>
    </div>
  );
};

const CareerTimeline = () => {
  return (
    <section id="timeline" className="timeline-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Career</span>
          <h2 className="heading-2">Professional Timeline</h2>
          <p className="section-subtitle">Three decades of engineering excellence and leadership</p>
        </div>
        
        <div className="timeline-container">
          <div className="timeline-track"></div>
          {timelineData.map((item, index) => (
            <TimelineItem 
              key={index} 
              item={item} 
              index={index}
              isLast={index === timelineData.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareerTimeline;
